import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class RegistryService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getDataTable({skip, limit}) {
        return Vue.axios.get(`${APIHOST}/api/Registry`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                skip: skip,
                limit: limit
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getRegistry(id) {
        return Vue.axios.get(`${APIHOST}/api/Registry`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getRegistryMails(id) {
        return Vue.axios.get(`${APIHOST}/api/RegistryMailReferences`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    getTempMail(uid) {
        return Vue.axios.get(`${APIHOST}/api/TempMail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    create(data) {
        return Vue.axios.post(`${APIHOST}/api/Registry`, data, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    getPdfPath(uid) {
        return `${APIHOST}/api/TempMailPdf/${uid}`
    }

    approveRegistryMail(uid) {
        return Vue.axios.put(`${APIHOST}/api/ApproveTempMail`, {}, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            }
        });
    }

    approveRegistry(id) {
        return Vue.axios.put(`${APIHOST}/api/ApproveRegistry`, {}, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            }
        });
    }

    getRegistriesReport({start, end}) {
        return Vue.axios.get(`${APIHOST}/api/RegistryReport`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }

    downloadRegistriesReport({start, end}) {
        const promise = Vue.axios.get(`${APIHOST}/api/RegistryReportDownload`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            responseType: 'blob',
            params: {
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
            },
            cancelToken: this.cancelTokenSource.token,
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Отчёт.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })

        return promise
    }
}

export default new RegistryService()